import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=666f1152&scoped=true&"
import script from "./fail.vue?vue&type=script&lang=js&"
export * from "./fail.vue?vue&type=script&lang=js&"
import style0 from "./fail.vue?vue&type=style&index=0&id=666f1152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f1152",
  null
  
)

export default component.exports